import { Loader2 } from "lucide-react";

export default function DownloadLoader() {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-black/20 z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-blue" />
        <p className="text-lg font-medium text-gray-600">Downloading Data...</p>
        <p className="text-sm text-gray-400">Please wait while we process your information</p>
      </div>
    </div>
  );
}
